import { atom } from "recoil"
import { SNACKBAR_TYPES } from "src/modules/const"

export const ShowToast = atom({
  key: "showToast",
  default: { show: false, text: "", type: SNACKBAR_TYPES.SUCCESS },
})
